import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { IdentityService } from "../identity.service";
import { KeycloakStateService } from "src/app/core/service/utility.service";
import { MatDialog } from "@angular/material/dialog";
import { SuccessDialogComponent } from "../../shared/dialogs/success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "../../shared/dialogs/error-dialog.component";

@Component({
  selector: 'app-identity-create-or-update',
  templateUrl: './identity-create-or-update.component.html',
  styleUrls: ['./identity-create-or-update.component.scss']
})
export class IdentityCreateOrUpdateComponent implements OnInit {

  form!: FormGroup;
  isCreate: boolean = true;
  identityList: any[] = [];
  selectedIdentityObj: any = null;

  selectedTab: 'selectIdentity' | 'createIdentity' = 'selectIdentity';
  isNext = true;

  showPassword: boolean = false;
  showSecret: boolean = false;

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  toggleSecret() {
    this.showSecret = !this.showSecret;
  }

  constructor(
    private identityService: IdentityService,
    private keycloak: KeycloakStateService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.isCreate = this.route.snapshot.data['create'];

    this.form = new FormGroup({
      selectedIdentity: new FormControl(null, Validators.required),

      username: new FormControl(null, Validators.required),
      role: new FormControl(null, Validators.required),
      affiliation: new FormControl(null, Validators.required),
      password: new FormControl(null),
      secret: new FormControl(null),

      firstName: new FormControl(null),
      lastName: new FormControl(null),
      email: new FormControl(null),
      guid: new FormControl(null),
      organization: new FormControl(null),
      status: new FormControl(null),
      dob: new FormControl(null),
    });

    this.loadIdentities();

    if (!this.isCreate) {
      const id = this.route.snapshot.paramMap.get('id');
      if (id) {
        this.loadIdentityForEdit(id);
      }

      this.selectedTab = 'createIdentity';
    }

    // existing selection logic (for create)
    this.form.get('selectedIdentity')?.valueChanges.subscribe((id) => {
      const selected = this.identityList.find((i: any) => i.id == id);

      if (selected) {
        this.setSelectedIdentity(selected);
      }
    });
  }

  onIdentityChange() {
    const id = this.form.get('selectedIdentity')?.value;

    const selected = this.identityList.find((i: any) => i.id == id);

    if (selected) {
      this.setSelectedIdentity(selected);
    }
  }

  setSelectedIdentity(selected: any) {

    this.selectedIdentityObj = selected;

    const names = selected.displayName?.split(' ') || [];

    this.form.patchValue({
      firstName: names[0] || '',
      lastName: names.slice(1).join(' ') || '',
      email: selected.mail,
      guid: selected.guid,
      organization: selected.organization,
      status: selected.status,
      dob: selected.date_of_birth
    });

    this.isNext = true;
  }

  loadIdentityForEdit(id: string): void {

    this.identityService.getIdentityById(id).subscribe((res: any) => {

      this.form.patchValue({
        username: res.username,
        role: res.role,
        affiliation: res.affiliation,
        selectedIdentity: res.digitalId
      });

      const selected = this.identityList.find(
        (i: any) => i.guid == res.digitalId || i.id == res.digitalId
      );

      if (selected) {
        this.setSelectedIdentity(selected);
      }
    });
  }

  loadIdentities(): void {
    this.identityService.getMergedIdentities(0).subscribe((res: any[]) => {
      this.identityList = res;
    });
  }

  goNext() {
    if (this.selectedIdentityObj) {
      this.selectedTab = 'createIdentity';
    }
  }

  getOrganizationId(): string {
    return this.keycloak.getOrganizationId();
  }

  submit(): void {

    if (!this.selectedIdentityObj) return;

    const selected = this.selectedIdentityObj;

    const firstName = this.form.value.firstName;
    const lastName = this.form.value.lastName;

    const payload = {
      organizationId: this.getOrganizationId(),
      digitalId: this.form.value.guid,
      username: this.form.value.username,
      firstName,
      lastName,
      email: selected.mail,
      password: this.form.value.password,
      secret: this.form.value.secret,
      affiliation: this.form.value.affiliation,
      role: this.form.value.role
    };

    this.identityService.createIdentity(payload)
      .subscribe(() => {
        this.router.navigate(['/secure-blockchain/auth-tools/identity/search']);
      });
  }

  cancel(): void {
    this.router.navigate(['/secure-blockchain/auth-tools/identity/search']);
  }


  openSuccessDialog(): void {
    const dialogRef = this.dialog.open(SuccessDialogComponent, {
      width: "250px",
      data: { isCreate: true, title: "Identity" },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools/identity/search']);
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: "250px",
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/secure-blockchain/auth-tools/identity/search']);
    });
  }
}